// extracted by css-extract-rspack-plugin
export default {"wrapper":"_608500ff","isSwiperCarousel":"_4e5847ac","title":"_a613034c","header":"_274dea93"};